import { Component, OnInit } from '@angular/core';
import { routerTransition } from '@app/router.animations';
import { KycService } from '@app/core/kyc.service';
import { AgentInfo } from '@app/core/models/agent';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class ThankYouComponent implements OnInit {
  agent: AgentInfo;
  brandName: string = "Wellnex";
  appLink: string = "http://www.my-insurer.net/download-wellnex-app.html";
  brandNameLink: string = "http://wellnex-singapore.com/";
  textColor = '#c53b67';
  isQuickKyc = environment.isQuickKyc;
  isWhatsAppRegister = false;
  constructor(
    private _kycService: KycService,
    private router: Router) {
    this.agent = new AgentInfo();
  }

  ngOnInit() {
    if (this._kycService.kyc.agentInfo) {
      this.agent = this._kycService.kyc.agentInfo;
    }
    this.isWhatsAppRegister = this._kycService.isWhatsAppRegister;
    const { customerId } = this._kycService.kyc.profile
    const data = {
      customerId,
      AgentId: this._kycService.agentInfo.id
    }
    let rs = this._kycService.kycInfo;
    this.brandName = rs.BrandName ? rs.BrandName : "Wellnex";
    this.appLink = rs.AppLink ? rs.AppLink : "http://www.my-insurer.net/download-wellnex-app.html";
    this.brandNameLink = rs.BrandNameLink ? rs.BrandNameLink : "http://wellnex-singapore.com/";
    this.textColor = rs.HeaderColor;
    //if (customerId) {
    //  this._kycService.sendEmailDowloadReportPDF(data).then(
    //    (res) => {
    //      console.log(res)
    //    }).catch(error => {
    //      alert(error)
    //    });
    //}
  }

  goToAppLink() {
    if (this.isQuickKyc && this.isWhatsAppRegister) {
      window.open(this.appLink, '_blank');
    }
  }

  startDownload() {
      window.open(this.appLink, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/features/thank-you/thank-you.component.ts